import type { ReactNode } from "react";
import styles from "./EmptyPlaceholder.module.css";

export interface EmptyPlaceholderProps {
  /** 空状态说明文案 */
  text?: ReactNode;
  className?: string;
  /** 插图尺寸，默认 128 */
  size?: number;
}

/**
 * 主题自适应空状态：插图走 `var(--empty-placeholder-img)`（浅/深色由 theme.css 切换）。
 */
export function EmptyPlaceholder({
  text,
  className = "",
  size = 128,
}: EmptyPlaceholderProps) {
  return (
    <div className={`${styles.root} ${className}`.trim()}>
      <div
        className={styles.img}
        style={{ width: size, height: size }}
        role="img"
        aria-hidden
      />
      {text != null && text !== "" ? (
        <p className={styles.text}>{text}</p>
      ) : null}
    </div>
  );
}
